import { render, staticRenderFns } from "./TeamResolutivityByMonth.vue?vue&type=template&id=58495ea8"
import script from "./TeamResolutivityByMonth.vue?vue&type=script&lang=js"
export * from "./TeamResolutivityByMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports